/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { collectionStatusSchema } from './collection-status';
import { collectionTypeSchema } from './collection-type';

export const collectionRowSchema = z.object({
  id: z.number(),
  parentId: z.number().nullable(),
  title: z.string(),
  slug: z.string(),
  description: z.string().nullable(),
  type: collectionTypeSchema,
  subject: z.string().nullable(),
  category: z.string().nullable(),
  difficulty: z.string().nullable(),
  year: z.number().nullable(),
  posterPath: z.string().nullable(),
  backdropPath: z.string().nullable(),
  thumbnailPath: z.string().nullable(),
  logoPath: z.string().nullable(),
  trailerPath: z.string().nullable(),
  genre: z.string().nullable(),
  rating: z.string().nullable(),
  tagline: z.string().nullable(),
  tmdbId: z.number().nullable().optional(),
  imdbId: z.string().nullable().optional(),
  originalLanguage: z.string().nullable().optional(),
  spokenLanguages: z.string().nullable().optional(),
  productionCountries: z.string().nullable().optional(),
  boxOffice: z.number().nullable().optional(),
  budget: z.number().nullable().optional(),
  runtimeMinutes: z.number().nullable().optional(),
  contentRating: z.string().nullable().optional(),
  releaseDate: z.string().nullable().optional(),
  source: z.string().nullable(),
  publishedChallengesCount: z.number(),
  playableChallengesCount: z.number().optional(),
  isFeatured: z.number(),
  isPremium: z.number(),
  titleInPoster: z.number().default(0),
  status: collectionStatusSchema,
  sortOrder: z.number(),
  createdBy: z.string().nullable(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export type ICollectionRow = z.infer<typeof collectionRowSchema>;
